module.exports = __webpack_public_path__ + "img/KhangTran.104f9a59.jpg";